export default __webpack_public_path__ + "static/LogoLong-c8b82a67e214f1ff661cbe45a9f5f6ea.png";